import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';

const localStorage = createLocalStorageProvider('jira-loss-aversion-standard');
const FIRST_MODAL_SEEN_AA = 'jla-first-modal-seen-aa';
const URGENT_MODAL_SEEN_AA = 'jla-urgent-modal-seen-aa';
const FIRST_MODAL_SEEN_AB = 'jla-first-modal-seen-ab';
const URGENT_MODAL_SEEN_AB = 'jla-urgent-modal-seen-ab';

export const setHasSeenFirstModalAA = () => {
	localStorage.set(FIRST_MODAL_SEEN_AA, true);
};

export const getHasSeenFirstModalAA = () => localStorage.get(FIRST_MODAL_SEEN_AA) || false;

export const setHasSeenUrgentModalAA = () => {
	localStorage.set(URGENT_MODAL_SEEN_AA, true);
};

export const getHasSeenUrgentModalAA = () => localStorage.get(URGENT_MODAL_SEEN_AA) || false;

export const setHasSeenFirstModalAB = () => {
	localStorage.set(FIRST_MODAL_SEEN_AB, true);
};

export const getHasSeenFirstModalAB = () => localStorage.get(FIRST_MODAL_SEEN_AB) || false;

export const setHasSeenUrgentModalAB = () => {
	localStorage.set(URGENT_MODAL_SEEN_AB, true);
};

export const getHasSeenUrgentModalAB = () => localStorage.get(URGENT_MODAL_SEEN_AB) || false;
